import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2C5282',
      light: '#4299E1',
      dark: '#1A365D',
      contrastText: '#fff',
    },
    secondary: {
      main: '#E53E3E',
      light: '#FC8181',
      dark: '#C53030',
      contrastText: '#fff',
    },
    success: {
      main: '#38A169',
      light: '#68D391',
      dark: '#276749',
    },
    warning: {
      main: '#D69E2E',
      light: '#F6E05E',
      dark: '#975A16',
    },
    background: {
      default: '#F7FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2D3748',
      secondary: '#718096',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
        },
        containedPrimary: {
          background: 'linear-gradient(45deg, #2C5282 30%, #4299E1 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #1A365D 30%, #2C5282 90%)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(45deg, #E53E3E 30%, #FC8181 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #C53030 30%, #E53E3E 90%)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        elevation1: {
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
        },
        elevation3: {
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.12)',
        },
      },
    },
  },
});

export default theme;